import { Component, computed, inject, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { RouterModule } from '@angular/router';
import { SanctumAuthService } from '@freesixtyfive/auth';
import { UserService } from '../../shared/services/user.service';
import { AppMenuItem, menuItems } from '../../app.navigation';

@Component({
  selector: 'app-start-page',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    CardModule,
    ButtonModule,
    RouterModule,
  ],
  templateUrl: './start-page.component.html',
  styleUrl: './start-page.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class StartPageComponent {
  #auth = inject(SanctumAuthService);
  #user = inject(UserService);

  firstName = this.#user.getUser()?.firstName ?? '';

  groups = computed(() => {
    if (!this.#auth.isAuth()) return [];
    const perms = this.#auth.permissions();

    return menuItems
      .filter((item) => item.items?.length)
      .map((group) => ({
        labelKey: group.label ?? '',
        icon: group.icon ?? '',
        cards: (group.items as AppMenuItem[]).filter(
          (child) =>
            child.dashboard &&
            (!child.permission || perms.includes(child.permission)),
        ),
      }))
      .filter((group) => group.cards.length > 0);
  });
}
